angular.module('unergie.main')
.directive('contractEnedisSimu', (BoFeaturesService, XmlParser, AlertManager, ErrorCatcher, ModalService) => ({
    restrict: 'E',
    scope: {
        contract: '=',
        idGrdContract: '=',
    },
    templateUrl: '/directives/contractEnedisSimu/contractEnedisSimu.html',
    link($scope) {
        $scope.env = BoFeaturesService.getEnv()

        // TEST BUTTONS
        const templateCxx = {
            status: 2,
            commissioning_date: null,
            decommissioning_date: null,
        }
        $scope.fieldsCxx = {
            status: {
                label: 'Statut',
                placeholder: 'Statut',
                type: 'select',
                enum: [
                    { value: 2, label: 'Actif' },
                    { value: 4, label: 'Résilié' },
                ],
            },
            commissioning_date: {
                label: `Date d'activation`,
                type: 'date',
            },
            decommissioning_date: {
                label: `Date de résiliation`,
                type: 'date',
            },
        }
        const resetCxxPayload = () => { $scope.CxxPayload = _.clone(templateCxx) }

        resetCxxPayload()

        const templateR04 = {
            end_date: moment(),
            index_nature: 'REEL',
            motivation: 'FACTU',
            triggering_event: 1,
        }
        const fieldsR04Template = {
            end_date: {
                label: 'Date de fin',
                type: 'date',
            },
            hp: {
                label: 'Conso HP',
                type: 'number',
            },
            hc: {
                label: 'Conso HC',
                type: 'number',
            },
            base: {
                label: 'Base',
                type: 'number',
            },
            triggering_event: {
                label: 'Evénement déclencheur',
                type: 'select',
                enum: [
                    { value: undefined, label: '' },
                    { value: 0, label: 'Facture de mise en service' },
                    { value: 1, label: 'Facture sur relevé' },
                    { value: 2, label: 'Facture d’acompte intermédiaire (ACI)' },
                    { value: 3, label: 'Facture événementielle' },
                    { value: 4, label: 'Facture de résiliation' },
                    { value: 9, label: 'Redressement' },
                ],
            },
            index_nature: {
                label: 'Nature index',
                type: 'select',
                enum: [
                    { value: '', label: '' },
                    { value: 'REEL', label: 'REEL' },
                    { value: 'ESTIME', label: 'ESTIME' },
                    { value: 'AUTO-RELEVE', label: 'AUTO-RELEVE' },
                ],
            },
            motivation: {
                label: 'Processus',
                type: 'select',
                enum: [
                    { value: '', label: '' },
                    { value: 'MES', label: 'MES' },
                    { value: 'CFN', label: 'CFN' },
                    { value: 'AUTRE', label: 'AUTRE' },
                    { value: 'FACTU', label: 'FACTU' },
                    { value: 'CMAT', label: 'CMAT' },
                    { value: 'REDRESS', label: 'REDRESS' },
                    { value: 'RES', label: 'RES' },
                ],
            },
        }

        const updateR04Template = function () {
            if ($scope.contract && $scope.contract.id_p_calendar === 'BASE') {
                delete $scope.R04Payload.hp
                delete $scope.R04Payload.hc
                delete $scope.fieldsR04.hp
                delete $scope.fieldsR04.hc
                $scope.R04Payload.base = ''
            } else {
                delete $scope.R04Payload.base
                delete $scope.fieldsR04.base
                $scope.R04Payload.hp = ''
                $scope.R04Payload.hc = ''
            }
        }

        const resetR04Payload = function () {
            $scope.R04Payload = _.clone(templateR04)
            $scope.fieldsR04 = _.clone(fieldsR04Template)
            updateR04Template()
        }

        resetR04Payload()

        $scope.resetR04Payload = resetR04Payload

        const templateX12 = {
            case_type: '',
            case_id: '',
        }
        $scope.fieldsX12 = {
            case_type: {
                label: 'Type Affaire',
                placeholder: 'Type Affaire',
                type: 'select',
                enum: [
                    { value: 'MES_OK', label: 'Mise en service OK' },
                    { value: 'MES_KO', label: 'Mise en service KO' },
                    { value: 'MES_CANCELLED', label: 'Mise en service annulée' },
                    { value: 'RIC_OK', label: 'Résiliation client OK' },
                    { value: 'RIC_KO', label: 'Résiliation client KO' },
                    { value: 'RIF_OK', label: 'Résiliation fournisseur OK' },
                    { value: 'RIF_KO', label: 'Résiliation fournisseur KO' },
                    { value: 'RPI_OK', label: 'Réduction de puissance OK' },
                    { value: 'RPI_KO', label: 'Réduction de puissance KO' },
                    { value: 'RST_OK', label: 'Restauration de la puissance réduite OK' },
                    { value: 'RST_KO', label: 'Restauration de la puissance réduite KO' },
                    { value: 'SAI_OK', label: 'Suspension de l’alimentation pour impayé OK' },
                    { value: 'SAI_KO', label: 'Suspension de l’alimentation pour impayé KO' },
                    { value: 'RET_OK', label: 'Rétablissement OK' },
                    { value: 'RET_KO', label: 'Rétablissement KO' },
                ],
            },
            case_id: {
                label: `ID de l'affaire`,
                type: 'text',
            },
        }
        const resetX12Payload = () => { $scope.X12Payload = _.clone(templateX12) }

        resetX12Payload()

        $scope.Cxx = function (cType) {
            const payload = _.clone($scope.CxxPayload)
            return XmlParser.generation({
                type: cType,
                target: 's3',
                bucket: `${$scope.env}-unergie-erdf`,
                id_contract: $scope.contract.id,
                id_grd: $scope.idGrdContract,
                payload,
            }).$promise.then(() => {
                AlertManager.success(`${cType} généré`)
                resetCxxPayload()
            }).catch(ErrorCatcher)
        }

        $scope.R04 = function () {
            const payload = _.clone($scope.R04Payload)
            if ((payload.end_date === '') || (payload.end_date === null) || (payload.end_date === undefined)) {
                payload.end_date = moment().format('YYYY-MM-DD')
            } else {
                payload.end_date = moment(payload.end_date).format('YYYY-MM-DD')
            }
            return XmlParser.generation({
                type: 'R04',
                target: 's3',
                bucket: `${$scope.env}-unergie-erdf`,
                id_contract: $scope.contract.id,
                id_grd: $scope.idGrdContract,
                payload,
            }).$promise.then(() => {
                AlertManager.success('R04 généré')
                resetR04Payload()
            }).catch(ErrorCatcher)
        }

        $scope.X12 = function () {
            const payload = _.clone($scope.X12Payload)
            return XmlParser.generation({
                type: 'X12',
                target: 's3',
                bucket: `${$scope.env}-unergie-files`,
                id_contract: $scope.contract.id,
                id_grd: $scope.idGrdContract,
                payload,
            }).$promise.then(() => {
                AlertManager.success('X12 généré')
                resetX12Payload()
            }).catch(ErrorCatcher)
        }

        $scope.openTestFeeModal = () => {
            ModalService.openModal({ type: 'addTestFeeModal', size: 'xlg' }, {
                idContract: $scope.contract.id,
                idGrd: $scope.idGrdContract,
            })
        }
    },
}))
